import { Link } from "react-router-dom";
import { Compass, Home, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-6 py-24 text-center" data-testid="not-found-page">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
        <Compass className="h-8 w-8" />
      </span>
      <h1 className="mt-6 font-display text-5xl font-medium tracking-tighter">404</h1>
      <p className="mt-3 text-lg text-muted-foreground">This page doesn't exist — but your next win does.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button asChild data-testid="notfound-home-btn">
          <Link to="/"><Home className="mr-1.5 h-4 w-4" /> Back home</Link>
        </Button>
        <Button asChild variant="outline" data-testid="notfound-roadmap-btn">
          <Link to="/free-roadmap">Get your free roadmap <ArrowRight className="ml-1.5 h-4 w-4" /></Link>
        </Button>
      </div>
    </div>
  );
}
